<template>
  <div class="main-search container page-section">
    <div class="main-search__header">
      <h1
        id="template-title"
        class="main-search__title text-mobile-paragraph-l-regular text-desktop-paragraph-l-regular col xs-span m4-8 text-center"
        v-text="$string('search.title')"
      />

      <div class="grid">
        <div class="col xs-span l4-9">
          <search-bar />

          <p
            v-if="count === 0 && state === 'ready'"
            class="main-search__empty-text text-mobile-paragraph-s-regular text-desktop-paragraph-s-regular"
            v-text="
              $string('search.empty', {
                replace: {
                  term: query,
                },
              })
            "
          />
        </div>
      </div>
    </div>

    <product-grid
      v-show="count > 0"
      template="search"
      :default-sort-by="$variable('search.sortBy')"
      :products-per-page="$variable('settings.pagination.products')"
      @state="state = $event"
    />
  </div>
</template>

<script>
/**
 * Vue: Main search (main-search)
 * -----------------------------------------------------------------------------
 * Main search page component.
 *
 */
import { mapState } from 'pinia';
import usePredictiveSearchStore from '~stores/predictive-search';

import ProductGrid from '~async/product-grid/product-grid';
import SearchBar from '~async/search-bar/search-bar';

export default {
  name: 'MainSearch',

  components: {
    ProductGrid,
    SearchBar,
  },

  data() {
    return {
      count: 0,
      state: 'initial-load',
    };
  },

  computed: {
    /**
     * Map Pinia state.
     */
    ...mapState(usePredictiveSearchStore, ['query']),
  },

  mounted() {
    cnvs.EventBus.listen('search:results', (count) => {
      this.count = count;
    });
  },
};
</script>

<style lang="scss">
@import './main-search';
</style>
